"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedTabBar = void 0;

var _Schema = require("../../Schema");

/**
 * A user taps an icon in the Tab Bar within the iOS app
 *
 * badge is true if present, false if not
 *
 * tab describes the icon tapped by the user
 *
 * @example
 * ```
 * tappedTabBar({
 *   badge: true,
 *   tab: "sell"
 * })
 * ```
 */
const tappedTabBar = ({
  badge,
  tab
}) => {
  return {
    action: _Schema.ActionType.tappedTabBar,
    badge: badge || false,
    context_module: _Schema.ContextModule.tabBar,
    context_screen_owner_type: _Schema.OwnerType.home,
    tab
  };
};

exports.tappedTabBar = tappedTabBar;